import * as t from "io-ts";
export const latitudeT = t.brand(t.number, (n) => n >= -90 && n <= 90, "Latitude");
export const longitudeT = t.brand(t.number, (n) => n >= -180 && n <= 180, "Longitude");
//# sourceMappingURL=lat-lon.js.map